module.exports = __webpack_public_path__ + "assets/img/banner3.f9d77cab.png";